import { render, staticRenderFns } from "./DinamicoGuiaGeneral.vue?vue&type=template&id=76096987"
import script from "./DinamicoGuiaGeneral.vue?vue&type=script&lang=js"
export * from "./DinamicoGuiaGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports